<script setup lang="ts">
import type { RtpProperties } from '@/pages/nstc/db/nstc-rtp-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'BULLETIN',
    },
})

const loading = ref(false)

const filter = ref({
  page: 1,
  size: 10,
  status: null,
  isTop: null,
  createdBy: null,
})

const formRef = ref(null)

const totalItems = ref(0)

const bulletinList = ref([])
const bodyPost = computed(() => {
  return {
    "data": {
      // "title": filter.value.title,
      // "content": filter.value.content,
      "status": filter.value.status,
      "isTop": filter.value.isTop,
      "createdBy": filter.value.createdBy,
    },
    "pageable": {
      "page": filter.value.page-1,
      "size": filter.value.size,
    }
  }
})

const statusOptions = ref([
  { status: '啟用', value: 'Y',isTop:'置頂' },
  { status: '停用', value: 'N',isTop:'不置頂' },
])

const editItemOriginal =ref({
  isNew: false,
  bulletinId: '',
  title: '',
  content: '',
  status: 'Y',
  publishDate: '',
  publishTime: '',
  isTop: 'N',
  createdBy: '',
})

const editItem = ref(JSON.parse(JSON.stringify(editItemOriginal.value)))

const grid1Headers = [
  // { title: '公告編號', key: 'bulletinId' },
  { title: '置頂', key: 'isTop' },
  { title: '標題', key: 'title' },
  { title: '內容', key: 'content' },
  { title: '狀態', key: 'status' },
  { title: '發布日期', key: 'publishDate' },
  { title: '發布時間', key: 'publishTime' },
  // { title: '建立人', key: 'createdBy' },
  { title: '操作', key: 'actions', sortable: false}
]

const isEditDrawerVisible = ref(false)
// API
const getList = async () => {
  loading.value = true
  try {
    const response = await $api('/bu/bulletin/getList', {
      method: 'POST',
      body: bodyPost.value,
    })
    bulletinList.value.splice(0, bulletinList.value.length, ...response.data.content)
    totalItems.value = response.data.totalElements
  } catch (error) {
    bulletinList.value.splice(0, bulletinList.value.length)
    totalItems.value = 0
    console.error(error)
  } finally {
    loading.value = false
  }
}

const save = async () => {
  const { valid, errors } = await formRef.value?.validate()
  console.log(valid, errors)
  if(!valid) return
  try {
    const response = await $api('/bu/bulletin/save', {
      method: 'POST',
      body: {
        ...editItem.value,
        publishDate:editItem.value.publishDate?`${noFormatDate(editItem.value.publishDate,'-')}`:'',
        publishTime:editItem.value.publishTime?`${noFormatTime(editItem.value.publishTime)}`:''
      },
    })
    isEditDrawerVisible.value = false
    $popSwal('success', '儲存成功', null)
    getList()
  }
  catch (error) {
    console.error(error)
    isEditDrawerVisible.value = false
    $popSwal('error', '儲存失敗', null)
  }
}

const openEditDrawer = (item: any) => {
  editItem.value = JSON.parse(JSON.stringify(item))
  isEditDrawerVisible.value = true
}

watch(filter.value, () => {
  getList()
},{immediate: true})

</script>

<template>
  <VCard>
    <v-row class="ma-0">
      <v-col cols="12" sm="10"  md="11" class="text-right d-flex align-center ga-1">
        <v-select v-model="filter.status" :items="statusOptions" item-title="status"
        item-value="value" label="狀態" class="mb-2" clearable/>
        <v-select v-model="filter.isTop" :items="statusOptions" item-title="isTop"
         item-value="value" label="是否置頂" class="mb-2" clearable/>
      </v-col>
      <v-col cols="12" sm="2"  md="1" >
        <VBtn variant="tonal" prepend-icon="tabler-plus" @click="openEditDrawer({...editItemOriginal, isNew: true})">新增</VBtn>
      </v-col>
    </v-row>
    <VDataTableServer
      v-model:items-per-page="filter.size"
      v-model:page="filter.page"
      :items="bulletinList"
      :items-length="totalItems"
      :headers="grid1Headers"
      :loading="loading"
      no-data-text="查無公告資料"
      class="text-no-wrap"
      hover
      :items-per-page="[
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' },
        { value: 100, title: '100' }
      ]"
      >
      <template #item.actions="{ item }">
        <VBtn variant="outlined" 
        icon
        @click="openEditDrawer({
          ...item, isNew: false,
          publishTime:item.publishTime?`${timeToFormat(item.publishTime)}`:'',
          publishDate:item.publishDate?`${westernToFormat(item.publishDate,'-')}`:''
        })">
          <v-icon icon="tabler-edit" />
        </VBtn>
      </template>
      <template #item.status="{ item }">
        <v-chip :color="item.status === 'Y' ? 'success' : 'error'" :text-color="item.status === 'Y' ? 'white' : 'white'">
          {{item.status === 'Y' ? '啟用' : '停用'}}
        </v-chip>
      </template>
      <template #item.isTop="{ item }">
        <v-icon icon="tabler-pin" v-if="item.isTop === 'Y'" />
      </template>
    </VDataTableServer>

    <VDialog v-model="isEditDrawerVisible" max-width="500" persistent scrollable>
      <DialogCloseBtn @click="isEditDrawerVisible=false" />
      <VCard :title="editItem.isNew ? '新增公告' : '編輯公告'">
        <VCardText>
          <VForm ref="formRef">
            <v-textarea v-model="editItem.title" auto-grow rows="1" label="標題" class="mb-3" :rules="[requiredValidator]"/>
            <v-textarea v-model="editItem.content" auto-grow rows="1" label="內容" class="mb-3"/>
            <v-text-field type="date" v-model="editItem.publishDate" label="發布日期" class="mb-3"/>
            <v-text-field type="time" v-model="editItem.publishTime" label="發布時間" class="mb-3"/>
            <v-switch v-model="editItem.status" :label="editItem.status === 'Y' ? '啟用' : '停用'" 
            false-value="N"
            true-value="Y"
            class="mb-3"/>
            <v-switch v-model="editItem.isTop" 
            :label="editItem.isTop === 'Y' ? '置頂' : '不置頂'" 
            false-value="N"
            true-value="Y"
            class="mb-3"/>
          </VForm>
        </VCardText>
        <VCardActions>
          <VSpacer />
          <VBtn variant="tonal" @click="save">儲存</VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </VCard>
</template>
